function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#B1C3CC;}\n\t.st1{fill:#0081FF;}\n");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  className: "st0",
  d: "M12,0H4C2.9,0,2,0.9,2,2v16c0,1.1,0.9,2,2,2h12c1.1,0,2-0.9,2-2V6L12,0z M16,18H4V2h7l5,5V18z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M10.1,14.3c-0.7,0-1.1-0.5-1.1-1.2s0.5-1.2,1.1-1.2c0.5,0,0.9,0.3,1,0.8h1c-0.1-1-0.9-1.7-2-1.7 c-1.2,0-2.2,0.9-2.2,2.1s0.9,2.1,2.2,2.1c1.1,0,1.9-0.7,2-1.8h-1C11,13.9,10.6,14.3,10.1,14.3z"
});

var SvgDocContractEst = function SvgDocContractEst(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDocContractEst, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/doc_contract_est.0d15148e.svg";
export { ForwardRef as ReactComponent };